import { render, staticRenderFns } from "./AddImagemContentComponent.vue?vue&type=template&id=b86e089e&scoped=true"
import script from "./AddImagemContentComponent.vue?vue&type=script&lang=js"
export * from "./AddImagemContentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86e089e",
  null
  
)

export default component.exports